import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Button, Form, Header, Input, Modal } from 'semantic-ui-react';
import {
  closeUpdateOwnerPhoneModal,
  setOwnerPhoneInput,
  setOwnerPhoneError,
  updateOwnerPhone,
} from 'state/business/actions';

const PHONE_PREFIX = '+62';

const toLocalPhoneDigits = phone => {
  if (!phone) return '';
  const withoutPrefix = phone.startsWith(PHONE_PREFIX)
    ? phone.slice(PHONE_PREFIX.length)
    : phone;
  return withoutPrefix.replace(/\D/g, '').replace(/^0+/, '');
};

export const EditOwnerPhoneModal = props => {
  const {
    updateOwnerPhoneModal,
    allBusiness,
    businessDetailsData,
    ownerPhoneInput,
    ownerPhoneError,
    updatingOwnerPhone,
    dispatch,
  } = props;

  const activeBusiness = businessDetailsData.data;
  const localPhoneDigits = toLocalPhoneDigits(ownerPhoneInput);

  const handleOnCancelButtonClick = () => {
    dispatch(closeUpdateOwnerPhoneModal());
  };

  const handleOnPhoneChange = (e, { value }) => {
    dispatch(setOwnerPhoneInput(`${PHONE_PREFIX}${toLocalPhoneDigits(value)}`));
    dispatch(setOwnerPhoneError(null));
  };

  const handleOnSaveButtonClick = () => {
    const businessId = allBusiness.data[allBusiness.activeIndex].id;
    dispatch(updateOwnerPhone({ businessId, phone: ownerPhoneInput }));
  };

  return (
    <Modal
      size="tiny"
      open={updateOwnerPhoneModal}
      onClose={handleOnCancelButtonClick}
    >
      <Header icon="user" content="Edit Owner" />
      <Modal.Content>
        {activeBusiness ? (
          <Form>
            <Form.Field>
              <label>Owner ID</label>
              <input value={activeBusiness.owner_id || ''} disabled />
            </Form.Field>
            <Form.Field>
              <label>Owner Name</label>
              <input value={activeBusiness.owner_name || ''} disabled />
            </Form.Field>
            <Form.Field>
              <label>Email</label>
              <input value={activeBusiness.owner_email || ''} disabled />
            </Form.Field>
            <Form.Field>
              <label>Phone Number</label>
              <Input
                label={PHONE_PREFIX}
                labelPosition="left"
                value={localPhoneDigits}
                onChange={handleOnPhoneChange}
                error={!!ownerPhoneError}
              />
            </Form.Field>
            {ownerPhoneError && (
              <div style={{ color: '#9f3a38', marginTop: '-0.5em' }}>
                {ownerPhoneError}
              </div>
            )}
          </Form>
        ) : (
          <></>
        )}
      </Modal.Content>
      <Modal.Actions>
        <Button
          color="green"
          loading={updatingOwnerPhone}
          disabled={
            !localPhoneDigits ||
            updatingOwnerPhone ||
            (!!activeBusiness &&
              localPhoneDigits === toLocalPhoneDigits(activeBusiness.phone))
          }
          onClick={handleOnSaveButtonClick}
        >
          Save
        </Button>
        <Button
          basic
          color="black"
          disabled={updatingOwnerPhone}
          onClick={handleOnCancelButtonClick}
        >
          Cancel
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

const mapStateToProps = ({ business }) => ({
  updateOwnerPhoneModal: business.updateOwnerPhoneModal,
  allBusiness: business.allBusiness,
  businessDetailsData: business.businessDetailsData,
  ownerPhoneInput: business.ownerPhoneInput,
  ownerPhoneError: business.ownerPhoneError,
  updatingOwnerPhone: business.updatingOwnerPhone,
});

EditOwnerPhoneModal.propTypes = {
  updateOwnerPhoneModal: PropTypes.bool.isRequired,
  allBusiness: PropTypes.object.isRequired,
  businessDetailsData: PropTypes.object.isRequired,
  ownerPhoneInput: PropTypes.string.isRequired,
  ownerPhoneError: PropTypes.string,
  updatingOwnerPhone: PropTypes.bool.isRequired,
  dispatch: PropTypes.func.isRequired,
};

EditOwnerPhoneModal.defaultProps = {
  ownerPhoneError: null,
};

export default connect(mapStateToProps)(EditOwnerPhoneModal);
